// 700 Bold
// 500 Medium
// 400 Book
// 300 Light
import { domainTheme } from '../config/config';

const fontFamily = 'GothamSSm, Helvetica, Arial, sans-serif';

const themeMUI = {
  palette: {
    primary: {
      main: domainTheme(window.location.hostname).main,
      light: '#DEE6E8',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#000000',
    },
  },
  typography: {
    fontSize: 12,
    fontFamily,
    h1: {
      fontFamily,
      fontWeight: 700,
      fontSize: '36px',
      lineHeight: '28px',
      letterSpacing: 0,
    },
    h2: {
      fontFamily,
      fontWeight: 700,
      fontSize: '24px',
      lineHeight: '26px',
      letterSpacing: '-0.05em',
    },
    h3: {
      fontFamily,
      fontWeight: 500,
      fontSize: '24px',
      lineHeight: '26px',
      // letterSpacing: '-0.05em',
    },
    h4: {
      fontFamily,
      fontWeight: 300,
      fontSize: '24px',
      lineHeight: '26px',
      letterSpacing: '-0.05em',
    },
    h5: {
      fontFamily,
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: '24px',
      letterSpacing: 0,
    },
    h6: {
      fontFamily,
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: 0,
    },
    body1: {
      fontFamily,
      fontWeight: 300,
      fontSize: '14px',
      lineHeight: '1.3em',
      letterSpacing: 0,
    },
    body2: {
      fontFamily,
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: '16px',
      letterSpacing: 0,
    },
    subtitle1: {
      fontFamily,
      fontWeight: 300,
      fontSize: '12px',
      lineHeight: '14px',
      letterSpacing: 0,
    },
    subtitle2: {
      fontFamily,
      fontWeight: 700,
      fontSize: '12px',
      lineHeight: '14px',
      letterSpacing: 0,
    },
    // caption: {
    //   fontFamily,
    //   fontWeight: 700,
    //   fontSize: '14px',
    //   lineHeight: '24px',
    //   letterSpacing: 0,
    // textTransform: 'uppercase',
    // },
  },
};

export default themeMUI;
